import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatTableDataSource, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PanelMember } from 'src/app/model/panel-member.model';
import { SelectionModel } from '@angular/cdk/collections';
import { PanelService } from 'src/app/shared/panel-service/panel.service';
import { PanelAsignService } from 'src/app/shared/panel-assign/panel-assign.service';

export interface DialogData {
  selectedPanelMemberPerPanel: string[];
  processId: number;
  onEditPanel: number;
}

@Component({
  selector: 'app-panel-member-list-modal',
  templateUrl: './panel-member-list-modal.component.html',
  styleUrls: ['./panel-member-list-modal.component.scss']
})
export class PanelMemberListModalComponent implements OnInit {

  filterName: string;
  panelMemberList = [];
  listData: MatTableDataSource<any>;
  private panelMembers: PanelMember[];
  private panelMemberSelectedList = [];
  private processId: number;
  private onEditPanel: number;
  assignedPanelMemberListData = [];
  
  displayedColumns: string[] = ['position', 'select', 'fullName', 'email', 'mobile'];

  
  constructor(
    private panelService: PanelService,
    private panelAsignService: PanelAsignService,
    public dialogRef: MatDialogRef<PanelMemberListModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public element: DialogData
  ) {
    element.selectedPanelMemberPerPanel = this.panelMemberSelectedList;
    this.processId = element.processId;
    this.onEditPanel = element.onEditPanel;
  }

  //for Check Box Selection in a table
  selection = new SelectionModel<any>(true, []);

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    if (this.listData != null) {
      const numSelected = this.selection.selected.length;
      const numRows = this.listData.data.length;
      return numSelected === numRows;
    }
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.listData.data.forEach(row => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }


  ngOnInit() {
    this.getAvailablePanelMembers();
  }

  getAllAssignedPanel() {
    this.panelAsignService.getPanelPanelMember(this.onEditPanel).then(
      panelAssignedDetails => {
        for (let i = 0; i < panelAssignedDetails.length; i++) {
          this.assignedPanelMemberListData.push(panelAssignedDetails[i].panelMemberId);
        }
        this.listData.data.forEach(row => {
          if ((this.assignedPanelMemberListData.indexOf(row.panelMemberId)) > -1) {
            this.selection.select(row);
          }
        }
        );
      },
      err => {
        console.log(err);
      }
    );
  }

  getAvailablePanelMembers() {
    this.panelService.availablePanelMember(this.processId).then(
      panelMembers => {
        this.panelMembers = panelMembers;
        if (this.panelMembers.length != 0) {
          this.listData = new MatTableDataSource(panelMembers);
          this.getAllAssignedPanel();
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  applyFilter(filterValue: string) {
    this.listData.filter = filterValue.trim().toLowerCase();
  }
  onClear() {
    this.listData.filter = '';
    this.filterName = '';
  }

  onClose() {
    this.dialogRef.close();
  }

  panelMemberChanged() {
    console.log(this.selection.selected);
    this.panelMemberSelectedList.push(this.selection.selected);
  }

  getPanelMemberIdForRow(panelPanelMember: any) {
    if (panelPanelMember) {
      return panelPanelMember.panelMemberId;
    } else {
      return "";
    }
  }
}
